import { Routes } from '@angular/router';
import { LandingUserComponent } from './components/landing-user/landing-user.component';
import { LandingOwnerComponent } from './components/landing-owner/landing-owner.component';
import { LoginComponent } from './components/login/login.component';
import { MenuComponent } from './components/menu/menu.component';
import { MyBookingsComponent } from './components/my-bookings/my-bookings.component';
import { ExploreComponent } from './components/explore/explore.component';
import { PrivacidadComponent } from './components/privacidad/privacidad.component';
import { PublicWithdrawalComponent } from './components/public-withdrawal/public-withdrawal.component';
import { TerminosComponent } from './components/terminos/terminos.component';
import { TerminosPropietariosComponent } from './components/terminos-propietarios/terminos-propietarios.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { SpaceDetailComponent } from './components/space-detail/space-detail.component';
import { SpaceCalendarComponent } from './components/space-calendar/space-calendar.component';
import { UserBookingComponent } from './components/user-booking/user-booking.component';
import { BookingPaymentComponent } from './components/booking-payment/booking-payment.component';
import { BookingFormalizationComponent } from './components/booking-formalization/booking-formalization.component';
import { AcceptTermsComponent } from './components/accept-terms/accept-terms.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { AdminPlatformBillingComponent } from './components/admin/admin-platform-billing/admin-platform-billing.component';
import { AdminInvoicesComponent } from './components/admin/admin-invoices/admin-invoices.component';
import { AdminEmailTemplatesComponent } from './components/admin/admin-email-templates/admin-email-templates.component';
import { AdminAmenitiesComponent } from './components/admin/admin-amenities/admin-amenities.component';
import { AdminCrmShellComponent } from './components/admin/admin-crm-shell/admin-crm-shell.component';
import { AdminCrmLeadsComponent } from './components/admin/admin-crm-leads/admin-crm-leads.component';
import { AdminUsersComponent } from './components/admin/admin-users/admin-users.component';
import { AdminCrmLeadDetailComponent } from './components/admin/admin-crm-lead-detail/admin-crm-lead-detail.component';
import { AdminCrmPipelinesComponent } from './components/admin/admin-crm-pipelines/admin-crm-pipelines.component';
import { OwnerManageBookingsComponent } from './components/owner-manage-bookings/owner-manage-bookings.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { OwnerPublicComponent } from './components/owner-public/owner-public.component';
import { SettingsComponent } from './components/settings/settings.component';
import { OwnerInvoicesComponent } from './components/owner-invoices/owner-invoices.component';
import { SpaceEmbedCalendarComponent } from './components/space-embed-calendar/space-embed-calendar.component';
import { SpaceEmbedPreviewComponent } from './components/space-embed-preview/space-embed-preview.component';
import { ProximamenteComponent } from './components/proximamente/proximamente.component';
import { MantenimientoComponent } from './components/mantenimiento/mantenimiento.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { legalGuard } from './guards/legal.guard';
import { phaseGuard } from './guards/phase.guard';

export const routes: Routes = [
  // ── App lifecycle pages — always accessible (no phaseGuard) ──────
  { path: 'proximamente',               component: ProximamenteComponent },
  { path: 'mantenimiento',              component: MantenimientoComponent },

  // ── Always-accessible support pages ──────────────────────────────
  { path: 'login',                      component: LoginComponent },
  { path: 'privacidad',                 component: PrivacidadComponent },
  { path: 'terminos',                   component: TerminosComponent },
  { path: 'terminos-propietarios',      component: TerminosPropietariosComponent },
  { path: 'desistimiento',              component: PublicWithdrawalComponent },

  // ── Phase-gated public routes ─────────────────────────────────────
  { path: '',                           component: LandingUserComponent,         pathMatch: 'full', canActivate: [phaseGuard] },
  { path: 'propietarios',               component: LandingOwnerComponent,        canActivate: [phaseGuard] },
  { path: 'explorar',                   component: ExploreComponent,             canActivate: [phaseGuard] },
  { path: 'propietario/:slug',          component: OwnerPublicComponent,         canActivate: [phaseGuard] },
  { path: 'espacio/:slugPais/:slugProvincia/:slugDistrito/:slugNombre', component: SpaceDetailComponent, canActivate: [phaseGuard] },
  { path: 'espacio/:slugProvincia/:slugDistrito/:slugNombre',           component: SpaceDetailComponent, canActivate: [phaseGuard] },
  { path: 'espacio/:id',                                                component: SpaceDetailComponent, canActivate: [phaseGuard] },
  // Booking flow: public URL (SEO slug) + auth gate; full-page layout (no menu shell).
  { path: 'espacio/:slugPais/:slugProvincia/:slugDistrito/:slugNombre/reservar', component: UserBookingComponent, canActivate: [phaseGuard, authGuard, legalGuard] },
  { path: 'espacio/:slugProvincia/:slugDistrito/:slugNombre/reservar',           component: UserBookingComponent, canActivate: [phaseGuard, authGuard, legalGuard] },
  { path: 'espacio/:id/reservar',                                                     component: UserBookingComponent, canActivate: [phaseGuard, authGuard, legalGuard] },
  { path: 'verificar-email',            component: VerifyEmailComponent,         canActivate: [phaseGuard] },
  { path: 'success', redirectTo: '/reserva/formalizar', pathMatch: 'full' },

  // Legal acceptance gate — auth-only (NOT legalGuard, to avoid redirect loop).
  { path: 'aceptar-terminos',           component: AcceptTermsComponent, canActivate: [authGuard] },

  // ── Protected layout shell ──────────────────────────────────────────
  {
    path: '',
    component: MenuComponent,
    canActivate: [phaseGuard, authGuard, legalGuard],
    children: [
      { path: 'app/explorar',               component: ExploreComponent },
      { path: 'dashboard', loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'mis-espacios', loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'mis-espacios/:spaceId/editar', loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent) },
      { path: 'gestionar-reservas',         component: OwnerManageBookingsComponent },
      { path: 'owner/manage-bookings',      redirectTo: 'gestionar-reservas', pathMatch: 'full' },
      { path: 'mis-reservas',               component: MyBookingsComponent },
      { path: 'facturas',                   component: OwnerInvoicesComponent },
      { path: 'ajustes',                    component: SettingsComponent },
      { path: 'admin', canActivate: [adminGuard], children: [
        { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
        { path: 'dashboard', component: AdminDashboardComponent },
        { path: 'settings', loadComponent: () => import('./components/admin/admin-settings/admin-settings.component').then(m => m.AdminSettingsComponent) },
        { path: 'billing', component: AdminPlatformBillingComponent },
        { path: 'invoices', component: AdminInvoicesComponent },
        { path: 'email-templates', component: AdminEmailTemplatesComponent },
        { path: 'amenities',       component: AdminAmenitiesComponent },
        { path: 'usuarios',        component: AdminUsersComponent },
        { path: 'crm/leads/:id',   component: AdminCrmLeadDetailComponent },
        { path: 'crm',             component: AdminCrmShellComponent, children: [
          { path: '', pathMatch: 'full', redirectTo: 'leads' },
          { path: 'leads',         component: AdminCrmLeadsComponent },
          { path: 'pipelines',     component: AdminCrmPipelinesComponent },
        ] },
      ] },
      { path: 'espacio/:id/calendario',                                                     component: SpaceCalendarComponent },
      { path: 'espacio/:slugPais/:slugProvincia/:slugDistrito/:slugNombre/calendario', component: SpaceCalendarComponent },
      { path: 'espacio/:slugProvincia/:slugDistrito/:slugNombre/calendario',           component: SpaceCalendarComponent },
      { path: 'booking/checkout/:spaceId',  component: BookingPaymentComponent },
      { path: 'reserva/pago',               redirectTo: '/explorar', pathMatch: 'full' },
      { path: 'reserva/:id/pago',           redirectTo: 'mis-reservas', pathMatch: 'full' },
      { path: 'reserva/formalizar',         component: BookingFormalizationComponent },
      { path: 'reserva/:bookingId/formalizar', component: BookingFormalizationComponent },
      { path: 'reserva/success',            redirectTo: 'reserva/formalizar', pathMatch: 'full' },
      { path: 'reserva/:id/confirmacion',   redirectTo: 'reserva/:id/formalizar', pathMatch: 'full' },
    ],
  },

  // ── Embed iframe — sin guards ni shell ────────────────────────────────────
  { path: 'embed/espacio/:id',          component: SpaceEmbedCalendarComponent },
  { path: 'embed/vista-previa/:id',     component: SpaceEmbedPreviewComponent },

  { path: '404',                        component: NotFoundComponent },
  { path: '**',                         component: NotFoundComponent },
];
